/**
 * SERVICE_PROVIDERS
 */
import { CacheService } from './cache';
import { LocalDbStorageService } from './local-db-storage';
import { CustomReportsService, ReportsService } from './reports';

export const BASE_ENTITY_SERVICES: any[] = [ReportsService, CustomReportsService, CacheService, LocalDbStorageService];

export const ENTITY_SERVICES: any[] = [...BASE_ENTITY_SERVICES];
